<template>
  <q-page class="bg-white">
    <q-card class="my-card" flat>
      <q-img
        :src="configTemplate_mainBackground"
        placeholder-src="hero-results-compressed-small.jpg"
        no-spinner
        alt=""
        height="250px">
        <div class="hero fit col wrap justify-center items-center content-center text-blur">

          <q-skeleton v-if="settings === null" type="text" tag="div" style="width: 50%; height: 5vh" animation="fade"></q-skeleton>
          <div v-else class="text-h1 text-center text-primary font-title">{{ eventName }}</div>

          <q-skeleton v-if="settings === null" type="text" tag="div" style="width: 30%; height: 3vh" animation="fade"></q-skeleton>
          <div v-else class="text-h5 text-center">{{ organizerName }}</div>

          <q-skeleton v-if="settings === null" type="text" tag="div" style="width: 70%; height: 3vh" animation="fade"></q-skeleton>
          <div v-else class="text-h6 text-center">{{ $t('live.ranking.show_number') }} {{settings.number}} - {{settings.name}}</div>
        </div>
      </q-img>
    </q-card>


    <div class="q-pa-md-md q-pa-sm q-pb-xl ios-mobile">

      <!-- documents link -->
      <div class="full-width row wrap justify-between q-mb-md bg-grey-4 q-pa-xs" style="border-radius: 20px">
        <q-btn rounded no-caps color="primary" icon="fa-solid fa-caret-left" size="sm" :label="$t('live.ranking.back')" :to="{name: 'LiveEvent', params: {event_id: $route.params.event_id}}" />
        <q-btn rounded no-caps color="primary" size="sm" :label="$t('live.ranking.timetable')" icon="fa-sharp fa-regular fa-clock" :to="{name: 'LiveTimetable', params: {event_id: $route.params.event_id, number: $route.params.number}}" />
      </div>
      <!-- end document link -->

      <div v-if="settings && settings.event.status === 'archive'" class="col-12 text-center">
        <q-icon name="fa-light fa-box-archive" size="lg"></q-icon>
        <p>{{ $t('live.event.archive') }}</p>
      </div>

      <!-- info épreuves -->
      <div class="full-width row items-center content-center q-ma-lg" v-if="showSettings && showSettings.event.status === 'open'">

        <div class="col-xs-12 col-md-6 col-sm-6 col-xl-6 q-gutter-sm" v-if="['dressage', 'cce', 'derby_eventing'].includes(showSettings.type) && (showSettings.test.dressage.b || showSettings.test.dressage.c || showSettings.test.dressage.e || showSettings.test.dressage.h || showSettings.test.dressage.m)">

          <span><strong>{{ $t('live.ranking.juges') }}</strong></span>
          <span v-if="showSettings.test.dressage.e" style="text-transform: capitalize"><q-badge color="primary">E</q-badge> {{ showSettings.test.dressage.e.name }}</span>
          <span v-if="showSettings.test.dressage.h" style="text-transform: capitalize"><q-badge color="primary">H</q-badge> {{ showSettings.test.dressage.h.name }}</span>
          <span v-if="showSettings.test.dressage.c" style="text-transform: capitalize"><q-badge color="primary">C</q-badge> {{ showSettings.test.dressage.c.name }}</span>
          <span v-if="showSettings.test.dressage.m" style="text-transform: capitalize"><q-badge color="primary">M</q-badge> {{ showSettings.test.dressage.m.name }}</span>
          <span v-if="showSettings.test.dressage.b" style="text-transform: capitalize"><q-badge color="primary">B</q-badge> {{ showSettings.test.dressage.b.name }}</span>

        </div>

        <div class="col-xs-12 col-md-6 col-sm-6 col-xl-6 reference-time" v-if="['cce', 'derby_eventing', 'derby_cross', 'crossindoor', 'jumping'].includes(showSettings.type)">
          <ul class="q-gutter-md">
            <li class="note text-uppercase" v-if="['cce', 'derby_eventing', 'derby_cross'].includes(showSettings.type)">
              {{ $t('live.ranking.eventing.time_ref') }} <q-badge class="text-weight-bold" rounded color="grey-4" text-color="primary" :label="showSettings.test.eventing.optimal_time_g ? showSettings.test.eventing.optimal_time_g : '--'" />
            </li>
            <li class="note text-uppercase" v-if="['cce', 'jumping', 'crossindoor'].includes(showSettings.type)">
              {{ $t('live.ranking.jumping.time_ref') }} <q-badge class="text-weight-bold" rounded color="grey-4" text-color="primary" :label="showSettings.test.jumping[0].optimal_time_g ? showSettings.test.jumping[0].optimal_time_g : '--'" />
            </li>
          </ul>
        </div>

        <!-- hunter -->
        <div class="col-6 q-gutter-sm" v-if="['hunter'].includes(showSettings.type)">
          <span><strong>{{ $t('live.ranking.profil') }}</strong> {{ showSettings.test.profil.name }}</span>
        </div>

        <div class="col-6 reference-time" v-if="['hunter'].includes(showSettings.type)">
          <ul class="q-gutter-md" v-if="showSettings.test.jumping">
            <li class="note">
              {{ $t('live.ranking.jumping.time_phase_1') }} <q-badge class="text-weight-bold" rounded color="grey-4" text-color="primary" :label="showSettings.test.jumping.manches[0].tps_phase_g ? showSettings.test.jumping.manches[0].tps_phase_g : '--'" />
            </li>
          </ul>
        </div>
        <!-- hunter -->

        <!-- CSO pure -->
        <div class="col-6 q-gutter-sm" v-if="['cso'].includes(showSettings.type)">
          <span><strong>{{ $t('live.ranking.profil') }}</strong> {{ showSettings.test.jumping.profil.name }}</span>
        </div>
        <div class="col-6 reference-time" v-if="['cso'].includes(showSettings.type)">
          <ul class="q-gutter-md" v-if="[1, 3, 19, 22, 122].includes(showSettings.test.jumping.profil.id)">
            <li class="note">
              {{ $t('live.ranking.jumping.time_phase_1') }} <q-badge class="text-weight-bold" rounded color="grey-4" text-color="primary" :label="showSettings.test.jumping.manches[0].tps_phase_g ? showSettings.test.jumping.manches[0].tps_phase_g : '--'" />
            </li>
          </ul>

          <ul class="q-gutter-md" v-if="[5, 281].includes(showSettings.test.jumping.profil.id)">
            <li class="note">
              {{ $t('live.ranking.jumping.time_phase_1') }} <q-badge class="text-weight-bold" rounded color="grey-4" text-color="primary" :label="showSettings.test.jumping.manches[0].tps_phase_1_g ? showSettings.test.jumping.manches[0].tps_phase_1_g : '--'" />
            </li>
            <li class="note">
              {{ $t('live.ranking.jumping.time_phase_2') }} <q-badge class="text-weight-bold" rounded color="grey-4" text-color="primary" :label="showSettings.test.jumping.manches[0].tps_phase_2_g ? showSettings.test.jumping.manches[0].tps_phase_2_g : '--'" />
            </li>
          </ul>

          <ul class="q-gutter-md" v-if="[2, 4, 6, 99].includes(showSettings.test.jumping.profil.id)">
            <li class="note">
              {{ $t('live.ranking.jumping.time_phase_1') }} <q-badge class="text-weight-bold" rounded color="grey-4" text-color="primary" :label="showSettings.test.jumping.manches[0].tps_phase_g ? showSettings.test.jumping.manches[0].tps_phase_g : '--'" />
            </li>
            <li class="note">
              {{ $t('live.ranking.jumping.time_phase_2') }} <q-badge class="text-weight-bold" rounded color="grey-4" text-color="primary" :label="showSettings.test.jumping.manches[1].tps_phase_g ? showSettings.test.jumping.manches[1].tps_phase_g : '--'" />
            </li>
          </ul>

          <ul class="q-gutter-md" v-if="[13].includes(showSettings.test.jumping.profil.id)">
            <li class="note">
              {{ $t('live.ranking.jumping.time_phase_2') }} <q-badge class="text-weight-bold" rounded color="grey-4" text-color="primary" :label="showSettings.test.jumping.manches[0].tps_phase_g ? showSettings.test.jumping.manches[0].tps_phase_g : '--'" />
            </li>
          </ul>
        </div>


      </div>
      <!-- info épreuves -->


      <!-- info championship -->
      <div class="full-width row items-center content-center q-ma-lg" v-if="$route.params.event_id === '2493' && $route.params.number === '2024_CI_0946_C_S_05_01'">
        <q-btn rounded no-caps color="primary" size="md"
               class="full-width"
               :label="$t('live.ranking.championship')"

               icon-right="fa fa-light fa-square-arrow-up-right"
               :to="{name: 'LiveRankingChp', params: {event_id: $route.params.event_id, number: $route.params.number}}" />
      </div>
      <!-- info chanmpionship -->

      <div class="full-width row items-center content-center" v-if="is_loading">
        <q-markup-table flat class="col-12">
          <thead>
          <tr>
            <th class="text-left" style="width: 150px">
              <q-skeleton animation="blink" type="text" />
            </th>
            <th class="text-right">
              <q-skeleton animation="blink" type="text" />
            </th>
            <th class="text-right">
              <q-skeleton animation="blink" type="text" />
            </th>
            <th class="text-right">
              <q-skeleton animation="blink" type="text" />
            </th>
            <th class="text-right">
              <q-skeleton animation="blink" type="text" />
            </th>
            <th class="text-right">
              <q-skeleton animation="blink" type="text" />
            </th>
          </tr>
          </thead>

          <tbody>
          <tr v-for="n in 5" :key="n">
            <td class="text-left">
              <q-skeleton animation="blink" type="text" width="85px" />
            </td>
            <td class="text-right">
              <q-skeleton animation="blink" type="text" width="50px" />
            </td>
            <td class="text-right">
              <q-skeleton animation="blink" type="text" width="35px" />
            </td>
            <td class="text-right">
              <q-skeleton animation="blink" type="text" width="65px" />
            </td>
            <td class="text-right">
              <q-skeleton animation="blink" type="text" width="25px" />
            </td>
            <td class="text-right">
              <q-skeleton animation="blink" type="text" width="85px" />
            </td>
          </tr>
          </tbody>
        </q-markup-table>
      </div>

      <!-- ranking -->
      <div class="full-width row items-center content-center" v-if="showSettings && ranking">
        <div class="col-12">
        <q-table
          class="table-challenge"
          virtual-scroll
          hide-pagination
          flat dense
          @row-click="goToRankingDetail"
          :table-style="{ padding: '0'}"
          :loading="is_loading"
          :loading-label="this.$i18n.t('system.loading')"
          :rows="ranking.ranking"
          :columns="generateColumns"
          :pagination="initialPagination"
          row-key="id">

          <!-- rank -->
          <template v-slot:body-cell-rank="props">
            <q-td :props="props">
              <div class="text-weight-bold">
                {{ props.value === '' ? '-' : props.value }}
              </div>
            </q-td>
          </template>

          <!-- horse -->
          <template v-slot:body-cell-horse="props">
            <q-td :props="props" style="max-width: 30vw">
              <div>
                <span class="text-weight-bold">{{ props.value.horse.name }} <q-icon v-if="props.row.horse.ctrl_veto" name="fa-sharp fa-regular fa-triangle-exclamation" color="red-10"><q-tooltip>Cheval au contrôle</q-tooltip></q-icon></span><br />
                <country-flag :country="props.value.rider.flag" v-if="settings.federation === 'fei'" size='small'/> {{ props.value.rider.firstname}} {{ props.value.rider.lastname.toUpperCase()}}<br />
                <span class="text-weight-light gt-xs" style="font-size: 10px">{{ riderHorseOrigin(props.value.horse) }}</span>
              </div>
            </q-td>
          </template>
          <!-- horse -->

          <!-- team -->
          <template v-slot:body-cell-team="props">
            <q-td :props="props">
              <div>
                <span class="text-weight-bold">{{ props.value.team.name.toUpperCase() }}</span>
              </div>
            </q-td>
          </template>
          <!-- team -->

          <!-- note dressage pur -->
          <template v-slot:body-cell-result-juge-dressage="props">
            <q-td :props="props">
              <div v-if="props.value">{{ props.value }}</div>
            </q-td>
          </template>
          <!-- note dressage pur -->


          <!-- note dressage CCE -->
          <template v-slot:header-cell-result-juge-dressage-cce="props">
            <q-th :props="props" class="gt-xs">
              {{props.col.label}}
            </q-th>
          </template>

          <template v-slot:body-cell-result-juge-dressage-cce="props">
            <q-td :props="props" class="gt-xs">
              <div v-if="props.value">{{ props.value !== '0.00' ? props.value + '%' : '-' }}</div>
            </q-td>
          </template>
          <!-- note dressage CCE -->

          <!-- total pts dressage cce -->
          <template v-slot:header-cell-result-dressage-cce-pts="props">
            <q-th :props="props" class="gt-xs">
              {{props.col.label}}
            </q-th>
          </template>

          <template v-slot:body-cell-result-dressage-cce-pts="props">
            <q-td :props="props" class="gt-xs">
              <div v-if="props.value.indice">{{ props.value.indice }}</div>
              <div v-else-if="props.value.total === 0">
                -
              </div>
              <div v-else>
                <span class="text-weight-bold">{{ props.value.total }}</span><br />
                {{ props.value.total_percent }}%
              </div>
            </q-td>
          </template>
          <!-- total pts dressage cce -->


          <template v-slot:header-cell-result-cce="props">
            <q-th :props="props" class="gt-xs">
              {{props.col.label}}
            </q-th>
          </template>

          <template v-slot:body-cell-result-cce="props">
            <q-td :props="props" class="gt-xs">
              <div v-if="props.value.indice">{{ props.value.indice }}</div>
              <div v-else-if="props.value.time > 0">
                <span class="text-weight-bold">{{ props.value.pts }}{{ props.value.pts_divers > 0 ? ' (+'+props.value.pts_divers+')' : ''}} / {{ props.value.pts_time }}</span><br />
                {{ props.value.time_g }}
              </div>
              <div v-else>
                -
              </div>
            </q-td>
          </template>


          <template v-slot:header-cell-result-cso="props">
            <q-th :props="props" class="gt-xs">
              {{props.col.label}}
            </q-th>
          </template>
          <template v-slot:body-cell-result-cso="props">
            <q-td :props="props" class="gt-xs">
              <div v-if="props.value.indice">{{ props.value.indice }}</div>
              <div v-else-if="props.value.time > 0">
                <span class="text-weight-bold">{{ props.value.pts }}{{ props.value.pts_divers > 0 ? ' (+'+props.value.pts_divers+')' : ''}} / {{ props.value.pts_time }}</span><br />
                {{ props.value.time }}"
              </div>
              <div v-else>
                -
              </div>
            </q-td>
          </template>

          <template v-slot:body-cell-result-crossindoor="props">
            <q-td :props="props">
              <div v-if="props.value.indice">{{ props.value.indice }}</div>
              <div v-else-if="props.value.time > 0">
                <span class="text-weight-bold">{{ props.value.pts }}{{ props.value.pts_divers > 0 ? ' (+'+props.value.pts_divers+')' : ''}} / {{ props.value.pts_time }}</span><br />
                {{ props.value.time_g }}"
              </div>
              <div v-else>
                -
              </div>
            </q-td>
          </template>


          <!-- cso tps diff -->
          <template v-slot:body-cell-result-jumping-diff="props">
            <q-td :props="props">
              <div v-if="props.value.indice">{{ props.value.indice }}</div>
              <div v-else-if="props.value.tps_phase_1 > 0">
                <span class="text-weight-bold">{{ props.value.pts }}{{ props.value.pts_divers > 0 ? ' (+'+props.value.pts_divers+')' : ''}} / {{ props.value.pts_time_phase_1 + props.value.pts_time_phase_2 }}</span><br />
                {{ props.value.tps_phase_1_g }} / {{ props.value.tps_phase_2_g }}
              </div>
              <div v-else>
                -
              </div>
            </q-td>
          </template>
          <!-- cso tps diff -->


          <!-- cso -->
          <template v-slot:body-cell-result-jumping="props">
            <q-td :props="props">
              <div v-if="props.value.indice">{{ props.value.indice }}</div>
              <div v-else-if="props.value.tps_phase > 0">
                <span class="text-weight-bold">{{ props.value.pts }}{{ props.value.pts_divers > 0 ? ' (+'+props.value.pts_divers+')' : ''}} / {{ props.value.pts_time }}</span><br />
                {{ props.value.tps_phase_g }}
              </div>
              <div v-else>
                -
              </div>
            </q-td>
          </template>
          <!-- cso -->


          <template v-slot:body-cell-result-total="props">
            <q-td :props="props">
              <div class="text-weight-bold">
                {{ props.value !== '' ? props.value : '-' }}
              </div>
            </q-td>
          </template>

        </q-table>

          <span style="font-style: italic" v-if="eventFederation === 'ffe-compet'"><q-icon name="fa-sharp fa-regular fa-triangle-exclamation" color="red-10"></q-icon> le cheval est au contrôle</span>
        </div>

      </div>
      <!-- ranking -->

    </div>
  </q-page>
</template>

<script>
import {
  parsed,
} from '@quasar/quasar-ui-qcalendar'
import { defineComponent, ref } from 'vue';
import {useMeta} from "quasar";
import CountryFlag from "vue-country-flag-next";
import {useStore} from "vuex";

export default defineComponent({
  name: 'LiveRanking',
  components: {
    CountryFlag
  },
  data () {
    return {
      title: ref(this.$i18n.t('system.loading')),
      meta_description: '',
      rider: ref(null),
      ranking: ref(null),
      is_loading: true,
      initialPagination: {
        page: 1,
        rowsPerPage: 3000
        // rowsNumber: xx if getting data from a server
      }
    }
  },
  preFetch ({ store, currentRoute, previousRoute, redirect, ssrContext, urlPath, publicPath }) {
    // fetch data, validate route and optionally redirect to some other route...
    // load timetable
    return store.dispatch("show/getSettings", {event_id: currentRoute.params.event_id, show_id: currentRoute.params.number})

    // ssrContext is available only server-side in SSR mode
  },
  computed: {
    generateColumns() {

      let columns = []

      columns.push({ name: 'rank', align: 'center', label: this.$i18n.t('live.ranking.rank'), field: row => row.rank, sortable: false })

      if (this.settings.federation === 'fei')
        columns.push({ name: 'bib', align: 'center', label: this.$i18n.t('live.ranking.tetiere_inter'), field: row => row.bib_ffe, sortable: false })
      else
        columns.push({ name: 'bib', align: 'center', label: this.$i18n.t('live.ranking.bib'), field: row => row.bib, sortable: false })


      if (Object.keys(this.ranking.ranking).length > 0 && this.ranking.ranking[0].rider)
        columns.push({ name: 'horse', align: 'left', label: this.$i18n.t('live.ranking.rider-horse'), field: row => row, sortable: false })

      if (Object.keys(this.ranking.ranking).length > 0 && this.ranking.ranking[0].team)
        columns.push({ name: 'team', align: 'left', label: this.$i18n.t('live.ranking.team'), field: row => row, sortable: false })


      if (['dressage'].includes(this.settings.type) ) {
        if (this.settings.test.dressage.e)
          columns.push({ name: 'result-juge-dressage', align: 'center', label: 'E', field: row => row.result.test.dressage.details.e, sortable: false })

        if (this.settings.test.dressage.h)
          columns.push({ name: 'result-juge-dressage', align: 'center', label: 'H', field: row => row.result.test.dressage.details.h, sortable: false })

        if (this.settings.test.dressage.c)
          columns.push({ name: 'result-juge-dressage', align: 'center', label: 'C', field: row => row.result.test.dressage.details.c, sortable: false })

        if (this.settings.test.dressage.m)
          columns.push({ name: 'result-juge-dressage', align: 'center', label: 'M', field: row => row.result.test.dressage.details.m, sortable: false })

        if (this.settings.test.dressage.b)
          columns.push({ name: 'result-juge-dressage', align: 'center', label: 'B', field: row => row.result.test.dressage.details.b, sortable: false })
      }


      if (['derby_eventing', 'cce'].includes(this.settings.type) ) {
        if (this.settings.test.dressage.e)
          columns.push({ name: 'result-juge-dressage-cce', align: 'center', label: '%E', field: row => row.result.test.dressage.details.e, sortable: false })

        if (this.settings.test.dressage.h)
          columns.push({ name: 'result-juge-dressage-cce', align: 'center', label: '%H', field: row => row.result.test.dressage.details.h, sortable: false })

        if (this.settings.test.dressage.c)
          columns.push({ name: 'result-juge-dressage-cce', align: 'center', label: '%C', field: row => row.result.test.dressage.details.c, sortable: false })

        if (this.settings.test.dressage.m)
          columns.push({ name: 'result-juge-dressage-cce', align: 'center', label: '%M', field: row => row.result.test.dressage.details.m, sortable: false })

        if (this.settings.test.dressage.b)
          columns.push({ name: 'result-juge-dressage-cce', align: 'center', label: '%B', field: row => row.result.test.dressage.details.b, sortable: false })
      }


      if (['cce', 'derby_eventing'].includes(this.settings.type) )
        columns.push({ name: 'result-dressage-cce-pts', align: 'center', label: this.$i18n.t('live.ranking.dressage.title'), field: row => row.result.test.dressage, sortable: false })

      if (['cce'].includes(this.settings.type) ) {


        if (this.settings.test_ordering[1] == 'eventing') {
          columns.push({ name: 'result-cce', align: 'center', label: this.$i18n.t('live.ranking.eventing.title'), field: row => row.result.test.eventing, sortable: false })
          columns.push({ name: 'result-cso', align: 'center', label: this.$i18n.t('live.ranking.jumping.title'), field: row => row.result.test.jumping[0], sortable: false })
        }
        else {
          columns.push({ name: 'result-cso', align: 'center', label: this.$i18n.t('live.ranking.jumping.title'), field: row => row.result.test.jumping[0], sortable: false })
          columns.push({ name: 'result-cce', align: 'center', label: this.$i18n.t('live.ranking.eventing.title'), field: row => row.result.test.eventing, sortable: false })
        }

      }

      if (['derby_cross', 'derby_eventing'].includes(this.settings.type) ) {
        columns.push({ name: 'result-cce', align: 'center', label: this.$i18n.t('live.ranking.eventing.title'), field: row => row.result.test.eventing, sortable: false })
      }

      if (['crossindoor'].includes(this.settings.type) ) {
        columns.push({ name: 'result-crossindoor', align: 'center', label: this.$i18n.t('live.ranking.eventing.title'), field: row => row.result.test.jumping[0], sortable: false })
      }


      // CSO
      if (['cso'].includes(this.settings.type) ) {

        this.settings.test.jumping.manches.forEach(function(manche, indexManche){

          if ([5].includes(this.settings.test.jumping.profil.id))
            columns.push({ name: 'result-jumping-diff', align: 'center', label: this.$i18n.t('live.ranking.jumping.title'), field: row => row.result.test.jumping.manches[indexManche], sortable: false })
          else if ([281].includes(this.settings.test.jumping.profil.id)) {

            if (indexManche === 0)
              columns.push({
                name: 'result-jumping-diff',
                align: 'center',
                label: this.$i18n.t('live.ranking.jumping.title'),
                field: row => row.result.test.jumping.manches[indexManche],
                sortable: false
              })
            else
              columns.push({ name: 'result-jumping', align: 'center', label: this.$i18n.t('live.ranking.jumping.title'), field: row => row.result.test.jumping.manches[indexManche], sortable: false })
          }
          else
            columns.push({ name: 'result-jumping', align: 'center', label: this.$i18n.t('live.ranking.jumping.title'), field: row => row.result.test.jumping.manches[indexManche], sortable: false })
        }.bind(this));

      }

      // hunter + cso
      if (['hunter'].includes(this.settings.type) && this.settings.test.jumping ) {

        this.settings.test.jumping.manches.forEach(function(manche, indexManche){
            columns.push({ name: 'result-jumping', align: 'center', label: this.$i18n.t('live.ranking.jumping.title'), field: row => row.result.test.jumping.manches[indexManche], sortable: false })
        }.bind(this));

      }

      columns.push({ name: 'result-total', align: 'center', label: this.$i18n.t('live.ranking.total'), field: row => row.result.total, sortable: false })

      return columns
    },
    eventName() {
      if (this.settings) {
        return this.settings.event.name
      }
      else
        return null
    },
    organizerName() {
      if (this.settings) {
        return this.settings.event.organizer.name
      }
      else
        return null
    },
    eventType() {
      if (this.settings) {
        return this.settings.event.type
      }
      else
        return null
    },
    eventFederation() {
      if (this.settings) {
        return this.settings.event.federation
      }
      else
        return null
    },
    showSettings() {
      if (this.settings)
        return this.settings
      else
        return null
    },
    eventTypeLabel() {

      if (!this.settings)
        return null

      switch (this.settings.event.type) {
        case 'cce':
          return this.$i18n.t('events.type.cce')
        case 'cso':
          return this.$i18n.t('events.type.cso')
        case 'dressage':
          return this.$i18n.t('events.type.dressage')
        case 'hunter':
          return this.$i18n.t('events.type.hunter')
        case 'derby_cross':
          return this.$i18n.t('events.type.derby_cross')
        case 'derby_eventing':
          return this.$i18n.t('events.type.derby_eventing')
        case 'crossindoor':
          return this.$i18n.t('events.type.crossindoor')
        default:
          return this.settings.event.type
      }
    },
    configTemplate_mainBackground() {
      if (this.configTemplate !== null && this.configTemplate.main_color) {
        return 'hero-results-compressed-tpl-' + this.configTemplate.main_color + '.jpg'
      }

      return 'hero-results-compressed-small.jpg'
    }
  },
  methods: {
    formatDate(dateInput) {
      const dateValue = parsed(dateInput + ' 00:00')
      return dateValue.day.toString().padStart(2, '0') + '/' + dateValue.month.toString().padStart(2, '0')  + '/' + dateValue.year.toString()
    },
    riderHorseOrigin(horse) {

      /*
      {
        "name": "Lancero Dancer",
        "origin": null,
        "color": "Bai",
        "pere": "Jaleo De Defey",
        "mere": null,
        "pere_mere": "Aceituno",
        "birthday": null
      }
       */

      let str = ''

      if (horse.pere && horse.pere.length > 0)
        str = str + horse.pere


      if (horse.pere && horse.pere.length > 0 && horse.pere_origin && horse.pere_origin.length > 0)
        str = str + ' ('+horse.pere_origin+')'



      if (horse.mere && horse.mere.length > 0) {

        if (horse.pere && horse.pere.length > 0)
          str = str + ' / '

        str = str + horse.mere


        if (horse.mere_origin && horse.mere_origin.length > 0)
          str = str + ' ('+horse.mere_origin+')'

      }

      if (horse.pere_mere && horse.pere_mere.length > 0) {

        if (horse.mere && horse.mere.length > 0)
          str = str + ' / '

        str = str + horse.pere_mere

        if (horse.pere_mere_origin && horse.pere_mere_origin.length > 0)
          str = str + ' ('+horse.pere_mere_origin+')'
      }

      return str
    },
    async goToRankingDetail(event, row) {
      if (this.settings.team_rule !== true)
        await this.$router.push({name: 'LiveRankingRider', params: {event_id: this.$route.params.event_id, number: this.$route.params.number, bib: row.bib}})
    }
  },
  setup () {

    const $store = useStore()
    const settings = $store.getters["show/settingsGetter"]

    const configTemplate = $store.getters["organizer/organizerTemplateGetter"]
    const customDomain = (configTemplate !== null)

    return {
      configTemplate,
      customDomain,
      settings,
    }
  },
  created: async function () {

    this.title = this.settings.event.name
    this.meta_description = this.$i18n.t('live.ranking.title') + ' ' + this.$i18n.t('live.ranking.show_number') + this.settings.number + ' ' + this.settings.name

    useMeta(() => {
      return {
        // whenever "title" from above changes, your meta will automatically update
        title: this.title,
        meta: {
          title: { content: this.title },
          ogTitle: { content: this.title },
          ogUrl: { content: this.$router.currentRoute._value.href },
          twitterUrl: { content: this.$router.currentRoute._value.href },
          twitterTitle: { content: this.title },
          ogDescription: { content: this.meta_description },
          twitterDescription: { content: this.meta_description },
          description: { name:'description', content: this.meta_description },
        }
      }
    })

    // get infos rider
    try {
      // get settings
      if (this.settings.event.status === 'open') {
        this.ranking = await this.$store.dispatch("show/getRanking", {
          event_id: this.$route.params.event_id,
          show_id: this.$route.params.number
        })
      }
      this.is_loading = false

    } catch (error) {
      this.$q.notify({
        textColor: 'white',
        icon: 'fa-light fa-times',
        message: this.$i18n.t('live.ranking.errors.fetch')
      })
    }

  },
})
</script>

<style scoped>
.table-challenge  ::v-deep(tr):nth-child(even) {
  background-color: #f3f3f4;
}
.table-challenge ::v-deep(tr):nth-child(odd) {
  background-color: #fdfdfd;
}

.table-challenge ::v-deep(td) {
  border-color: transparent;
  height: 30px;
}

.hero .text-h5, .hero .text-h6 {
  color: #272727;
  font-weight: initial;
}

.hero {
  background: none;
}

.reference-time ul {
  display: flex;
  list-style: none;
  flex-direction: row;
  float: right;
}

.small-flag {
  margin: -0.9em -1.2em -1.1em -1.2em;
}
</style>
